export default class Header {
  constructor() {
    this.header = '#header'
    this.$header = $(this.header)
    this.numberScroll = 0
    this.scrollTop = 0
    this.lastScrollTop = 0
    this.class = 'pin-header'

    this.$topBar = $('.header-top-bar')
    this.topBarHovered = false
  }

  init() {
    if (this.$header.length) {
      this.updateHeaderHeightVar()
      this.scrollPinHeader()

      if (this.$topBar.length) {
        this.$topBar.on('mouseenter', () => {
          this.topBarHovered = true
          this.$header[0].style.transform = ''
        })
        this.$topBar.on('mouseleave', () => {
          this.topBarHovered = false
        })
      }
    }
  }

  updateHeaderHeightVar() {
    const height = this.$header[0].clientHeight - 10;
    document.documentElement.style.setProperty('--header-height-desktop', `${height}px`)
    document.documentElement.style.setProperty('--header-height-tablet', `${height}px`)
    document.documentElement.style.setProperty('--header-height-mobile', `${height}px`)
  }

  scrollPinHeader() {
    this.settingPin()
    $(window).on('scroll resize orientationchange', () => {
      this.settingPin()
    })
    $(window).on('resize', () => {
      this.updateHeaderHeightVar()
    })
    $(window).on('orientationchange', () => {
      // orientationchange fires before the browser finishes reflowing the new
      // layout (especially iOS Safari), so offsetHeight here can still reflect
      // the old orientation. Wait a tick for layout to settle before reading it.
      setTimeout(() => this.updateHeaderHeightVar(), 50)
    })
  }

  // Mobile/tablet landscape (below desktop): auto-hide the whole header
  isLandscapeMobile() {
    return window.matchMedia('(max-width: 1199px) and (orientation: landscape)').matches
  }

  settingPin() {
    this.scrollTop = $(window).scrollTop()
    const scrollDelta = this.scrollTop - this.lastScrollTop

    if (this.scrollTop > this.numberScroll) {
      this.$header.addClass(this.class)
    } else {
      this.$header.removeClass(this.class)
    }

    if (this.isLandscapeMobile()) {
      // Hide the full header on scroll down, show it on scroll up
      const headerHeight = this.$header[0].offsetHeight
      if (scrollDelta > 5 && this.scrollTop > headerHeight) {
        this.$header[0].style.transform = `translateY(-${headerHeight}px)`
      } else if (scrollDelta < -5 || this.scrollTop <= 0) {
        this.$header[0].style.transform = ''
      }
    } else if (this.$topBar.length && this.$topBar[0].offsetHeight > 0 && !this.topBarHovered) {
      // Desktop: hide only the top bar on scroll down, show on scroll up
      const topBarHeight = this.$topBar[0].offsetHeight
      if (scrollDelta > 5 && this.scrollTop > topBarHeight) {
        this.$header[0].style.transform = `translateY(-${topBarHeight}px)`
      } else if (scrollDelta < -5 || this.scrollTop <= 0) {
        this.$header[0].style.transform = ''
      }
    } else {
      // Portrait mobile (header is `absolute`, no top bar) — clear any leftover
      // transform from a previous landscape/desktop state on rotate.
      this.$header[0].style.transform = ''
    }

    this.lastScrollTop = this.scrollTop
  }
}
new Header().init()
